import React from 'react';
import './DonutChart.css';

/**
 * DonutChart – SVG donut with legend
 * @param {Array} segments - [{ label, val, color }]
 */
export default function DonutChart({ segments = [] }) {
  const total = segments.reduce((s, d) => s + (d.value || 0), 0) || 1;
  const r = 50;
  const cx = 60;
  const cy = 60;
  let cumulative = 0;

  const arcs = segments.map((seg) => {
    const pct = (seg.value || 0) / total;
    const circ = 2 * Math.PI * r;
    const dash = pct * circ;
    const offset = -(cumulative * circ);
    cumulative += pct;
    return { ...seg, dash, offset, circ };
  });

  return (
    <div className="donut-chart">
      <svg width="120" height="120" className="donut-chart__svg">
        {arcs.map((arc, i) => (
          <circle
            key={i}
            cx={cx} cy={cy} r={r}
            fill="none"
            stroke={arc.color}
            strokeWidth="18"
            strokeDasharray={`${arc.dash} ${arc.circ}`}
            strokeDashoffset={arc.offset}
            style={{ transformOrigin: `${cx}px ${cy}px`, transform: 'rotate(-90deg)' }}
          />
        ))}
        <circle cx={cx} cy={cy} r={r - 9} fill="var(--bg-card)" />
        <text x={cx} y={cy + 5} textAnchor="middle" fill="var(--text)" fontSize="13" fontWeight="800" fontFamily="'Space Mono',monospace">
          {Number(total || 0).toLocaleString()}
        </text>
      </svg>

      <div className="donut-chart__legend">
        {segments.map((s, i) => (
          <div className="donut-chart__legend-item" key={i}>
            <span className="donut-chart__dot" style={{ background: s.color }} />
            <span>{s.label}: <strong>{Number(s.value || 0).toLocaleString()}</strong></span>
          </div>
        ))}
      </div>
    </div>
  );
}
